import { getGuidelineList } from "../../utils/getConstants.js";
import { isNullOrEmpty } from "../../utils/isNullOrEmpty.js";

const glList = getGuidelineList(true);

export const filterMenuItems = ({ glObj, menuJson }) => {
  let menuItems = { items: [], title: "" };
  const { glPage, submenu } = glObj;
  const filteredSubmenu = submenu.filter((path) => path !== "");
  let glInfo;
  if (!isNullOrEmpty(glPage)) {
    const index = glPage.replaceAll("_", "").toLowerCase();
    glInfo = glList.find((gl) => gl.iconClassSuffix === index);
    if (
      !isNullOrEmpty(glInfo) &&
      !isNullOrEmpty(menuJson) &&
      menuJson.hasOwnProperty("menuItems")
    ) {
      menuItems = {
        items: menuJson.menuItems,
        title: glInfo.linkText,
      };

      if (submenu.length > 0) {
        menuItems = filteredSubmenu.reduce((acm, curr) => {
          if (curr === "" || acm.items.length === 0) return acm;
          const item = acm.items.find((item) => {
            const decodedId = item.id ? decodeURIComponent(item.id) : "";
            return decodedId.includes(`/${curr}`) || item.msPath.includes(`_${curr}`);
          });
          return item
            ? { items: item.children, title: item.title }
            : { items: [], title: "" };
        }, menuItems);
      }
    }
  }
  return { menuItems, glInfo, rootGuideline: filteredSubmenu.length === 0 };
};

export const filterResourceLinks = (links) => {
  return (
    links?.filter((link) => link.title.toLowerCase() === "what's new") ?? []
  );
};

export const filterContributorLinks = (links) => {
  return (
    links?.filter((link) => link.title.toLowerCase() !== "what's new") ?? []
  );
};